import {
  Component, ChangeDetectorRef,
  OnChanges, Input,
} from '@angular/core';
import * as _ from 'lodash';

import { packagingUomData } from 'shared/item-detail/packaging/packaging-uom';
import { PermissionsService } from 'shared/permissions/permissions.service';
import { ProductDetailsService } from '../../product-details.service';
import { ProductPanelService } from '../../../product-panel/product-panel.service';

import { BaseSegmentComponent } from '../base/_base-segment.component';
import { fieldsInfo } from './fields-info';


@Component({
  moduleId: module.id,
  selector: 'packaging-segment',
  templateUrl: 'packaging.component.html',
  styleUrls: ['packaging.component.scss'],
})
export class PackagingComponent extends BaseSegmentComponent implements OnChanges {

  @Input() extendedInformation: any[];

  packagePathName: string = 'packages';
  expiCodesPathName: string = 'extendedInformation';
  headers: string[] = [
    'title', 'orderable', 'quantity'
  ];
  headersData: any[];
  dimensions: string[] = [
    'dimensions.length', 'dimensions.width',
    'dimensions.height', 'dimensions.uom'
  ];
  weight: string[] = [
    'weight_variance', 'weights.weight',
    'weights.dimensional_weight', 'weights.uom'
  ];
  packagesData: any[] = [];
  fieldsInfo: any = fieldsInfo;

  constructor(
    protected productDetailsService: ProductDetailsService,
    protected productPanelService: ProductPanelService,
    private ref: ChangeDetectorRef,
    protected permissionsService: PermissionsService,
  ) {
    super(
      productDetailsService,
      productPanelService,
      permissionsService
    );
  }

  ngOnChanges() {
    this.prepareData();
    console.log(this.packagesData);
  }

  prepareData() {
    this.data = this.orderBy(this.data);
    this.getTableHeaders();

    const packagesData = _.map(packagingUomData, (uom: any) => {
      const keyName = uom.uom;
      const val: any = _.get(this.itemDetail, 'packages.' + keyName);

      const data = this.getPackageFields(keyName, this.data);
      const headers = this.separateData(data, this.headers);
      const dimensions = this.separateData((<any>headers)['false'], this.dimensions);
      const weight = this.separateData((<any>dimensions)['false'], this.weight);
      const regulated = this.separateData((<any>weight)['false'], ['hazardous_materials.0.regulated']);
      const hazmat = this.separateData((<any>regulated)['false'], ['hazardous_materials.0']);
      return this.jsonifyData(
        true, val, (<any>headers)['true'], (<any>dimensions)['true'],
        (<any>weight)['true'], (<any>regulated)['true'],
        (<any>hazmat)['true'], (<any>hazmat)['false']
      );
    });
    (<any>packagesData)[0].collapsed = false;
    this.packagesData = packagesData;
    this.setErrors();
  }

  getTableHeaders() {
    this.headersData = _.map(this.headers, (name: string) => {
      return _.find(this.data, (item: any) => {
        return this.matchItemName(item.item_name, '.' + name);
      });
    });
  }

  separateData(data: any, names: string[]): any {
    return _.groupBy(data, (item: any) => {
     return _.some(names, (property: string) => {
        return this.matchItemName(item.item_name, '.' + property);
      });
    });
  }

  getPackageFields(name: string, data: any[]): any {
    return data.filter((item: any) => this.matchItemName(item.item_name + '.', name));
  }

  matchItemName(itemName: any, value: string) {
    return itemName.indexOf(value) !== -1;
  }

  jsonifyData(
    collapsed: boolean, packageData: any, headers: any, dimensions: any,
    weight: any, regulated: any, hazmat: any, other: any
   ): any {
    return {
      'collapsed': collapsed,
      'packageData': packageData,
      'headersData': headers,
      'dimensionalData': dimensions,
      'weightData': weight,
      'regulatedData': regulated,
      'hazmatData': hazmat,
      'defaultData': other,
    };
  }

  getPackageProperty(item: any) {
    return this.getItemProperty(item, this.packagePathName + '.' + item.item_name);
  }

  isFullSizeField(fieldMap: string) {
    return (_.indexOf(this.fieldsInfo.fullSizeFields, fieldMap) >= 0);
  }

  setErrors() {
    // set errors for packages and its fields
    _.forEach(this.packagesData, pkg => {
      this.setPackageError(pkg);
    });
    // set errors for expi_codes
    _.forEach(this.extendedInformation, code => {
      code.hasError = this.hasError('extendedInformation.' + code.item_name);
    });
    this.ref.markForCheck();
  }

  setPackageError(pkg: any) {
    if (!this.itemDetail || !this.itemDetail.validation) { return; }
    let error = false; // accumulator for package error
    _.forEach(_.keys(pkg), (key: any): any => {
      switch (key) {
        case 'headersData':
        case 'dimensionalData':
        case 'weightData':
        case 'regulatedData':
        case 'hazmatData':
        case 'defaultData':
          _.forEach(pkg[key], (field: any): any => {
            // check whether field value is invalid
            const fieldError = this.hasError('packages.' + field.item_name);
            field.hasError = fieldError;
            // error becomes true if at least one field is invalid
            error = error || fieldError;
          });
          break;
        default:
          break;
      }
    });
    pkg.hasError = error;
    this.ref.markForCheck();
  }
}
